export default "__VITE_ASSET__02c4e338__"